import { render, staticRenderFns } from "./tabFinancePartnerCapitalApply.vue?vue&type=template&id=19aba96d&"
import script from "./tabFinancePartnerCapitalApply.vue?vue&type=script&lang=ts&"
export * from "./tabFinancePartnerCapitalApply.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports